<template>
  <div>

    <!-- 已脱敏 -->
    <div v-if="lookEncryption">{{memoValue}}</div>

    <!-- 未脱敏 -->
    <div v-if="!lookEncryption && !quickFlag">

      <!-- 手动加载 -->
      <div class="hoverIconKz memoImg_style">
        <span class="memo_quick" @click="openQuick"></span>
        <span class="memoImg_text" :style="{width:queryWidth}" :title="memoValue" v-html="memoValue"></span>
        <span class="memoImg_button" @click="enlargeImg" v-if="memoImgFlag">
          <Icon title="点击查看大图" type="images" size="20" color="#5cadff"></Icon>
        </span>
      </div>
    </div>

    <div v-if="quickFlag">
      <Poptip v-model="quickFlag" trigger="click" width=200 transfer :showPop="closeModal">
        <div class="hoverIconKz memoImg_style">
          <span class="memo_quick" ></span>
          <span class="memoImg_text" :style="{width:queryWidth}" :title="memoValue" v-html="memoValue"></span>
          <span class="memoImg_button" @click="enlargeImg" v-if="memoImgFlag">
            <Icon title="点击查看大图" type="images" size="20" color="#5cadff"></Icon>
         </span>
        </div>
        <div slot="content">
          <Button @click="editMemo(item.memo)" class="itemBtn" type="primary" size="small" v-for="item in quick.list" :key="item.id">{{item.memo}}</Button>
        </div>
      </Poptip>
    </div>

    <div v-if="memoHoverFlag">
      <Poptip v-model="memoHoverFlag" trigger="click" width=400 transfer>
        <div slot="content">
          <div class="memo_hover" v-if="memoHoverData.length">
              <h1>追踪次数：{{memoHoverData.length}}</h1>
              <p v-for="(item,index) in memoHoverData" :key="index" v-text="item.yymemo"></p>
          </div>
          <div v-else class="memo_hover">
            <h1>暂无记录</h1>
          </div>
        </div>
      </Poptip>
    </div>

  </div>
</template>

<script>
  import {dataDst} from "../../common/util"

  export default {
    name: "render-memo",
    props: {
      encryption: {
        type: Boolean
      },
      memo: {
        type: String
      },
      memoImg: {
        type: String
      },
      kzId:{
        type:String
      },
      customWidth:{
        type:[String,Number]
      }
    },
    data() {
      return {
        memoHoverFlag:false,
        memoValue: '',
        quick: {
          open: false,
          list:[],
        },
        quickFlag:false,
        closeModal: '关闭',
        memoHoverData:[],
        memoHoverConfig:{
          left:0,
          top:0,
        }
      }
    },
    computed: {
      //脱敏权限
      lookEncryption() {
        if (this.memo) {
          this.memoValue = this.encryption ? dataDst(this.memo) : this.memo
        }

        return this.encryption
      },

      //备注
      memoImgFlag() {
        return this.memoImg
      },

      queryWidth(){
        return `${this.customWidth}px`
      },
    },
    methods: {

      openQuick(){
        this.quickFlag = true
        this.getQuick()
      },

      //获取快捷备注
      getQuick(){
        this.$http.get("/memo/get_fast_memo_list").then(data=>{
          if(data.code == 100000){
            this.quick.list = data.data
          }else{
            this.$Message.error(data.msg)
          }
        })
      },

      //查看大图
      enlargeImg() {
        document.getElementById('modalImgUrl').src = this.memoImg
        document.getElementById('modalImg').style.display = 'block'
        document.getElementById('modalImg').onclick = () => {
          document.getElementById('modalImgUrl').src = ''
          document.getElementById('modalImg').style.display = 'none'
        }
      },

      //快捷备注
      editMemo(memo) {
        this.$http.get('edit/edit_fast_memo',{
          params:{
            kzId:this.kzId,
            memo:memo
          }
        }).then(data=>{
          if(data.code == 100000){
            this.$Message.success(data.msg)
            this.memoValue = memo + this.memoValue
            this.closeModal = '关闭'
          }else{
            this.$Message.error(data.msg)
          }
        })
      },

      //
      memoHover(e){
        this.memoHoverFlag = true
        this.$http.get(`plat/get_dsyy_log_by_kzid?kzid=${this.kzId}`).then(data=>{
          if(data.code == 100000){
            this.memoHoverData = data.data
          }
        })
      },
    }
  }
</script>

<style lang="less">
  .memoImg_style {
    display: flex;
    justify-content: end;
    align-items: center;
    .memoImg_text {
      height: 30px;
      line-height: 30px;
      text-overflow: ellipsis;
      cursor: pointer;
    }
    .quick_list{
      width:200px;
    }
    .memo_quick{
      display: inline-block;
      width:20px;
      height:30px;
      cursor: pointer;
    }
    .memoImg_button {
      cursor: pointer;
      margin-top: 3px;
    }
  }

  .memo_hover{
    width:100%;
    white-space: pre-line;
    margin-bottom:8px;
  }
  .memo_hover h1{
    font-weight: bold;
    font-size:12px;
    line-height:24px;
  }
  .memo_hover p{
    width:100%;
    font-size:12px;
    border:1px #eed solid;
    padding:4px;
    margin-top:8px;
  }

  .itemBtn{
    float:left;
    margin:10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/render-components/render-memo.vue